<div class='bubble' *ngIf='bubble.visible' fxLayout="row" [style.top.px]='bubble.top' [style.left.px]='bubble.left'
  fxLayoutAlign="center center">
  <div>
    <p>Don't have an event planned?</p>
    <p>Go ahead and plug in a test event to see how it works!</p>
  </div>
</div>

<div mat-dialog-title>
  <h1 class='center' *ngIf='isStepTwo'>Step Two:</h1>
  <h1 class='center' *ngIf='bubble.visible'>WELCOME TO Golf GamesKeeper!</h1>
  <div class='center' *ngIf='bubble.visible' class='intro-message'>
    Here is your first step to golf greatness:
  </div>
</div>
<div mat-dialog-title class='center'>Create New Event</div>
<div mat-dialog-content fxLayout="column" fxLayout="start stretch" fxLayoutGap="10px">
  <div fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="150px" style="padding-top:20px;padding-bottom: 20px;">
    <div>
      <div class='s18-font' *ngIf='!addRoundToMultiRound()' style="margin-bottom: 12px;">
        <label>
          Multi Round
        </label>
        <mat-slide-toggle [checked]="isMultiRound" labelPostion='after' (change)='toggleMultiRound()' required>
        </mat-slide-toggle>
      </div>
      <div class='s18-font' *ngIf='!addRoundToMultiRound()'>
        <label>
          Ryder Cup
        </label>
        <mat-slide-toggle [checked]="isRyderCup" labelPostion='after' (change)='toggleRyderCup()' required>
        </mat-slide-toggle>
      </div>
    </div>
    <div>
      <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
        <div>
          Holes:
        </div>
        <mat-button-toggle-group #nbrOfHolesGroup="matButtonToggleGroup" value="18">
          <mat-button-toggle value="18" style="width:100px">
            18
          </mat-button-toggle>
          <mat-button-toggle value="9" style="width:100px">
            9
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>
  <mat-form-field>
    <mat-label>Group</mat-label>
    <mat-select placeholder="Group" [(ngModel)]="eventGroupId" (selectionChange)='onSelectGroup()' required
      [disabled]='disabled.group'>
      <mat-option *ngFor="let group of allGroups" [value]='group.group_id'>
        {{ group.group_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Event Name</mat-label>
    <input matInput [(ngModel)]="eventName" placeholder="Event Name" required [disabled]='addRoundToMultiRound()'>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="date" placeholder="Date"
      ng-model-options="{ timezone: 'utc' }" (change)='checkDate()' required [disabled]='disabled.date'>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field *ngIf='!isMultiRound'>
    <mat-label>Time</mat-label>
    <input matInput type='time' [(ngModel)]="time" placeholder="Time" required>
  </mat-form-field>
  <mat-form-field *ngIf='!isMultiRound'>
    <mat-label>Scoring</mat-label>
    <mat-select id='basics7' placeholder="Scoring" [(ngModel)]="eventScoring" [disabled]='disabled.scoring'>
      <mat-option *ngFor="let scoring of availEventScoring" [value]='scoring.id'>
        {{ scoring.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf='!isMultiRound' style="width:100%">
    <mat-form-field id='pick-state'>
      <mat-label>State</mat-label>
      <mat-select placeholder="State" [(ngModel)]="eventState" (selectionChange)='getCourses()'
        [disabled]='disabled.course'>
        <mat-option *ngFor="let state of allStates" [value]='state.state'>
          {{ state.state }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id='pick-course' *ngIf="!searchingCourse">
        <mat-label>Course</mat-label>
        <mat-select placeholder="Course" [(ngModel)]="eventCourseId" (selectionChange)='getTees()'
          [disabled]='disabled.course'>
          <mat-option *ngIf='!eventState'>Select State First</mat-option>
          <mat-option *ngFor="let course of courses" [value]='course.course_id'>
            {{ course.coursename }}
          </mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="searchingCourse" style="height:46px;padding-top:15px">
      Getting Courses ... <i class="fa fa-spinner fa-spin"></i>
    </div>
    <mat-form-field id='pick-tees' *ngIf="!searchingTees">
      <mat-label>Tees</mat-label>
      <mat-select placeholder="Tees" [(ngModel)]="eventTeesId">
        <mat-option *ngIf='!eventCourseId'>Select Course First</mat-option>
        <mat-option *ngFor="let tee of tees" [value]='tee.tees_id'>
          {{ tee.teename }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="searchingTees" style="height:46px;padding-top:15px">
        Getting Tees ... <i class="fa fa-spinner fa-spin"></i>
    </div>
  </div>
  <div *ngIf='error' class='warn-color'>{{error}}</div>
</div>
<div mat-dialog-actions fxLayout='row' fxLayoutAlign='center center' fxLayoutGap="7px">
  <button mat-raised-button class='orange-button' (click)="createEvent()" tabindex="2">Create Event
    <i *ngIf='sendingRequest' class='fa fa-spinner fa-spin fa-fw'></i>
  </button>
  <button mat-button mat-dialog-close tabindex="-1">Nevermind</button>
</div>